export enum TransferView {
  SEARCH = 1,
  STATISTICS = 3,
  ABROAD = 4,
  HOME_ACTIVE = 5,
  HOME_INACTIVE = 6,
  NEW_TRANSFER_HOME = 7,
  NEW_TRANSFER_ABROAD = 8,
}
